import React from "react";
import { motion } from "framer-motion";
import { SectionHeader } from "./Services";
import { photoUrl, isVideo } from "@/lib/api";

export default function About({ content, photos = [] }) {
  const a = content?.about || {};
  const preferred = ["operador-01.jpg", "control-02.jpg", "lacasa-01.jpg"];
  let photo = null;
  for (const f of preferred) { photo = photos.find((p) => p.filename === f); if (photo) break; }

  return (
    <section id="nosotros" className="relative py-24 sm:py-28 px-5 sm:px-8 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <SectionHeader eyebrow="Nosotros" title={a.title || "Acompañamos infraestructuras críticas hace más de una década"} sub={a.body} />
        <div className="mt-14 grid lg:grid-cols-12 gap-10 items-start">
          <div className="lg:col-span-5">
            {photo && (
              <div className="img-hover relative">
                {isVideo(photo)
                  ? <video src={photoUrl(photo)} autoPlay muted loop playsInline className="w-full aspect-[4/5] object-cover" />
                  : <img src={photoUrl(photo)} alt="" className="w-full aspect-[4/5] object-cover" />}
                <div className="brand-stripe" style={{ width: "30%", top: "75%", left: "-5%" }} />
              </div>
            )}
            <blockquote className="mt-6 border-l-2 border-brand pl-5">
              <p className="text-fg-2 text-[17px] italic leading-relaxed">“{a.quote}”</p>
              <div className="mt-3 text-mute text-[12px] tracking-wider">{a.quote_author}</div>
            </blockquote>
          </div>
          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-2 gap-px bg-line-2 border border-line-2">
              {(a.pillars || []).map((p, i) => (
                <motion.div key={i} initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.45, delay: i*0.06 }}
                  className="bg-surface p-6">
                  <div className="text-faint text-[11px] font-medium tracking-wider">0{i+1}</div>
                  <h4 className="mt-3 text-fg text-[18px] font-semibold leading-tight">{p.title}</h4>
                  <p className="mt-2 text-mute text-[14px] leading-relaxed">{p.text}</p>
                </motion.div>
              ))}
            </div>
            <div className="mt-8">
              <div className="eyebrow eyebrow-mute mb-4">Sectores que acompañamos</div>
              <div className="flex flex-wrap gap-2">
                {(a.sectors || []).map((s, i) => (
                  <span key={i} className="px-3 py-1.5 border border-line text-fg-2 text-[13px]">{s}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
